export default "/images/frontPageBackgroundImage1920x1280.png?1928660bd0434b3be245366699680bff";